// Global UI Interactions, Search, and Timers for EUROPECASE

document.addEventListener('DOMContentLoaded', () => {
  initScrollNav();
  initMobileMenu();
  initCountdowns(document);
  initSearchOverlay();
  initEuropecaseMotion(document);
  requestAnimationFrame(() => document.documentElement.classList.add('ec-page-ready'));
});

document.addEventListener('shopify:section:load', (event) => {
  initCountdowns(event.target);
  initEuropecaseMotion(event.target);
});

// 1. Navigation Scroll Effect
function initScrollNav() {
  const nav = document.getElementById('site-nav');
  if (nav) {
    const updateNav = () => {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    };
    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }
}

// 2. Mobile Menu Toggle
function initMobileMenu() {
  const btn = document.getElementById('mobile-menu-btn');
  const menu = document.getElementById('mobile-menu');
  if (btn && menu) {
    menu.classList.remove('hidden');
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      const icon = btn.querySelector('.material-symbols-outlined');
      if (icon) icon.textContent = isOpen ? 'close' : 'menu';
    });
  }
}

// 3. EUROPECASE motion system: lightweight, observer-driven and accessibility-aware.
function initEuropecaseMotion(scope = document) {
  if (document.documentElement.classList.contains('ec-animations-off') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('ec-motion-ready');

  if (!('IntersectionObserver' in window)) return;

  if (!window.ecRevealObserver) {
    window.ecRevealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
  }

  const root = scope.querySelectorAll ? scope : document;
  const singleSelectors = [
    '.ec-section-head',
    '.ec-page-head',
    '.ec-footer-grid',
    '.product-media-section',
    '.product-form-section',
    '.ec-product-gallery',
    '.ec-product-details',
    '.ec-product-campaign',
    '.ec-contact-intro',
    '.ec-contact-form-wrap',
    '.ec-legal-sidebar',
    '.ec-legal-content',
    '.ec-content-page__body',
    '#main-cart-page > .ec-shell',
    '[id^="search-results-"] > .ec-shell'
  ];

  root.querySelectorAll(singleSelectors.join(',')).forEach((element) => {
    if (element.dataset.ecMotionBound) return;
    element.dataset.ecMotionBound = 'true';
    element.dataset.ecReveal = 'section';
    window.ecRevealObserver.observe(element);
  });

  root.querySelectorAll('.ec-product-grid, .ec-collection-grid, .ec-values-grid, .ec-review-grid').forEach((grid) => {
    Array.from(grid.children).forEach((card, index) => {
      if (card.dataset.ecMotionBound) return;
      card.dataset.ecMotionBound = 'true';
      card.dataset.ecReveal = 'card';
      card.style.setProperty('--ec-reveal-delay', `${Math.min(index % 6, 5) * 75}ms`);
      window.ecRevealObserver.observe(card);
    });
  });

  root.querySelectorAll('.thumb-item, .ec-product-feature').forEach((item, index) => {
    if (item.dataset.ecMotionBound) return;
    item.dataset.ecMotionBound = 'true';
    item.dataset.ecReveal = 'card';
    item.style.setProperty('--ec-reveal-delay', String(Math.min(index, 5) * 60) + 'ms');
    window.ecRevealObserver.observe(item);
  });
}

// 4. Shared campaign countdown: looping by default, optionally fixed to a real date
function initCountdowns(scope = document) {
  const root = scope.querySelectorAll ? scope : document;
  const countdowns = root.querySelectorAll('[data-ec-countdown]');

  countdowns.forEach((countdown) => {
    if (countdown.dataset.countdownBound === 'true') return;

    const mode = countdown.dataset.mode === 'fixed' ? 'fixed' : 'loop';
    const durationHours = Math.max(1, Number(countdown.dataset.durationHours) || 3);
    const durationMs = durationHours * 60 * 60 * 1000;
    let target = 0;

    countdown.dataset.countdownMode = mode;
    countdown.dataset.countdownDuration = String(durationMs);

    if (mode === 'loop') {
      target = getLoopCountdownTarget(countdown, Date.now());
      if (durationHours < 24) countdown.classList.add('is-short');
    } else {
      target = Date.parse(countdown.dataset.end || '');
      if (!Number.isFinite(target)) {
        countdown.classList.add('is-unconfigured');
        countdown.textContent = 'BİTİŞ TARİHİ AYARLANMADI';
        countdown.setAttribute('aria-label', countdown.textContent);
        target = 0;
      }
    }

    countdown.dataset.countdownTarget = String(target);
    countdown.dataset.countdownBound = 'true';
  });

  updateCountdowns();

  if (!window.ecCountdownInterval) {
    window.ecCountdownInterval = window.setInterval(updateCountdowns, 1000);
  }
}

function getLoopCountdownTarget(countdown, now) {
  const durationMs = Number(countdown.dataset.countdownDuration) || (3 * 60 * 60 * 1000);
  const durationHours = Math.max(1, Number(countdown.dataset.durationHours) || 3);
  const key = countdown.dataset.countdownKey || 'europecase-campaign';
  const storageKey = 'europecase_loop_' + key + '_' + durationHours;
  let target = 0;

  try {
    target = Number(window.localStorage.getItem(storageKey));
  } catch (error) {
    target = 0;
  }

  if (!target || target <= now) {
    target = now + durationMs;
    try {
      window.localStorage.setItem(storageKey, String(target));
    } catch (error) {
      // The loop still works for the current page if storage is unavailable.
    }
  }

  return target;
}

function updateCountdowns() {
  const now = Date.now();

  document.querySelectorAll('[data-ec-countdown]').forEach((countdown) => {
    if (countdown.classList.contains('is-unconfigured')) return;

    let target = Number(countdown.dataset.countdownTarget);
    let difference = target - now;

    if (difference <= 0 && countdown.dataset.countdownMode === 'loop') {
      target = getLoopCountdownTarget(countdown, now);
      countdown.dataset.countdownTarget = String(target);
      difference = target - now;
    }

    if (!target || difference <= 0) {
      if (!countdown.classList.contains('is-expired')) {
        countdown.classList.add('is-expired');
        countdown.textContent = countdown.dataset.expiredText || 'KAMPANYA SONA ERDİ';
        countdown.setAttribute('aria-label', countdown.textContent);
      }
      return;
    }

    const days = Math.floor(difference / 86400000);
    const hours = Math.floor((difference % 86400000) / 3600000);
    const minutes = Math.floor((difference % 3600000) / 60000);
    const seconds = Math.floor((difference % 60000) / 1000);

    updateCountdownUnit(countdown, '[data-countdown-days]', days);
    updateCountdownUnit(countdown, '[data-countdown-hours]', hours);
    updateCountdownUnit(countdown, '[data-countdown-minutes]', minutes);
    updateCountdownUnit(countdown, '[data-countdown-seconds]', seconds);

    countdown.setAttribute(
      'aria-label',
      days + ' gün ' + hours + ' saat ' + minutes + ' dakika ' + seconds + ' saniye'
    );
  });
}

function updateCountdownUnit(countdown, selector, value) {
  const unit = countdown.querySelector(selector);
  if (!unit) return;

  const nextValue = String(value).padStart(2, '0');
  if (unit.textContent === nextValue) return;

  unit.textContent = nextValue;
  unit.classList.remove('is-changing');
  void unit.offsetWidth;
  unit.classList.add('is-changing');
}

// 5. Search Overlay & Realtime Searching
function initSearchOverlay() {
  if (document.getElementById('search-overlay-container')) return;

  const container = document.createElement('div');
  container.id = 'search-overlay-container';
  container.innerHTML = `
    <div id="search-overlay" class="fixed inset-0 z-[10001] flex flex-col opacity-0 pointer-events-none transition-all duration-300">
      <!-- Header -->
      <div class="ec-shell flex h-[88px] flex-shrink-0 items-center justify-between border-b border-line">
        <span class="brand-wordmark" id="search-brand-wordmark"></span>
        <button id="close-search" class="ec-icon-button">
          <span class="material-symbols-outlined text-[24px]">close</span>
        </button>
      </div>

      <!-- Search Input Wrapper -->
      <div class="max-w-3xl mx-auto px-6 w-full py-16 flex-shrink-0">
        <form action="/search" method="get" class="relative border-b border-line pb-4 transition-colors focus-within:border-brand">
          <span class="material-symbols-outlined absolute left-0 top-1/2 -translate-y-1/2 text-[32px] text-muted">search</span>
          <input type="text" name="q" id="search-input" placeholder="Tasarım veya model arayın..." class="w-full border-none bg-transparent p-0 pl-12 pr-4 text-xl font-light text-ink outline-none placeholder:text-muted/60 focus:ring-0 sm:text-2xl" autocomplete="off" />
        </form>
      </div>

      <!-- Live Search Results -->
      <div class="max-w-3xl mx-auto px-6 w-full flex-grow overflow-y-auto pb-20 custom-scroll">
        <div id="search-results-grid" class="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <!-- Dynamic results -->
        </div>
        <div id="search-empty-state" class="hidden space-y-3 py-20 text-center text-muted">
          <span class="material-symbols-outlined text-[48px]">search_off</span>
          <p class="text-xs font-bold uppercase tracking-wider">Sonuç bulunamadı.</p>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(container);

  const searchBrand = document.getElementById('search-brand-wordmark');
  if (searchBrand) {
    searchBrand.append(document.createTextNode(window.theme?.brandName || 'EUROPECASE'));
    if (window.theme?.showBrandStar) {
      const star = document.createElement('span');
      star.className = 'brand-wordmark__star';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = window.theme?.brandStar || '✦';
      searchBrand.appendChild(star);
    }
  }

  // Toggle events
  window.toggleSearchOverlay = (show) => {
    const overlay = document.getElementById('search-overlay');
    const mainEl = document.querySelector('main') || document.body.firstElementChild;
    if (show) {
      overlay.classList.add('active');
      if (mainEl) mainEl.classList.add('main-blur');
      document.getElementById('search-input').focus();
    } else {
      overlay.classList.remove('active');
      if (mainEl) mainEl.classList.remove('main-blur');
      document.getElementById('search-input').value = '';
      document.getElementById('search-results-grid').innerHTML = '';
      document.getElementById('search-empty-state').classList.add('hidden');
    }
  };

  document.getElementById('close-search').addEventListener('click', () => toggleSearchOverlay(false));
  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.getElementById('search-overlay').classList.contains('active')) {
      toggleSearchOverlay(false);
    }
  });

  // Realtime search query
  const input = document.getElementById('search-input');
  input.addEventListener('input', () => {
    performLiveSearch(input.value.trim());
  });
}

function performLiveSearch(query) {
  const grid = document.getElementById('search-results-grid');
  const emptyState = document.getElementById('search-empty-state');
  
  if (query.length < 2) {
    grid.innerHTML = '';
    emptyState.classList.add('hidden');
    return;
  }

  fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`)
    .then(response => response.json())
    .then(data => {
      const products = data.resources.results.products;
      grid.innerHTML = '';
      
      if (products && products.length > 0) {
        emptyState.classList.add('hidden');
        products.forEach(prod => {
          const itemHtml = `
            <a href="${prod.url}" class="ec-search-result flex items-center gap-4 p-3 transition-colors hover:border-brand">
              <div class="h-16 w-16 flex-shrink-0 overflow-hidden bg-surface">
                <img src="${prod.image}" class="w-full h-full object-cover" alt="${prod.title}" />
              </div>
              <div>
                <h4 class="text-xs font-bold uppercase text-ink">${prod.title}</h4>
                <p class="text-brand text-xs font-black mt-1">${prod.price_formatted || (prod.price / 100) + ' TL'}</p>
              </div>
            </a>
          `;
          grid.insertAdjacentHTML('beforeend', itemHtml);
        });
      } else {
        emptyState.classList.remove('hidden');
      }
    })
    .catch(() => {
      grid.innerHTML = '';
      emptyState.classList.remove('hidden');
    });
}

// 5. Product Card Selectors & AJAX Add to Cart
window.onCardBrandChange = function(brandSelect) {
  const form = brandSelect.closest('.product-card-form');
  if (!form) return;
  
  const modelSelect = form.querySelector('.card-model-select');
  const atcBtn = form.querySelector('.card-atc-btn');
  const variantIdInput = form.querySelector('.card-variant-id');
  const brandIndex = parseInt(form.getAttribute('data-brand-index'));
  const modelIndex = parseInt(form.getAttribute('data-model-index'));
  
  const variantsJson = JSON.parse(form.querySelector('.card-variant-json').textContent);
  
  // Clear and reset model dropdown
  modelSelect.innerHTML = '<option value="">Model Seçin</option>';
  modelSelect.disabled = true;
  variantIdInput.value = '';
  setCardButtonActive(atcBtn, false);
  
  const selectedBrand = brandSelect.value;
  if (!selectedBrand) {
    modelSelect.innerHTML = '<option value="">Önce Marka Seçin</option>';
    return;
  }
  
  // Filter models for selected brand
  const availableModels = new Set();
  variantsJson.forEach(variant => {
    if (variant.options[brandIndex] === selectedBrand) {
      availableModels.add(variant.options[modelIndex]);
    }
  });
  
  // Populate options
  if (availableModels.size > 0) {
    modelSelect.disabled = false;
    availableModels.forEach(model => {
      const opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      modelSelect.appendChild(opt);
    });
  }
};

window.onCardModelChange = function(modelSelect) {
  const form = modelSelect.closest('.product-card-form');
  if (!form) return;
  
  const brandSelect = form.querySelector('.card-brand-select');
  const atcBtn = form.querySelector('.card-atc-btn');
  const variantIdInput = form.querySelector('.card-variant-id');
  const brandIndex = parseInt(form.getAttribute('data-brand-index'));
  const modelIndex = parseInt(form.getAttribute('data-model-index'));
  
  const selectedBrand = brandSelect.value;
  const selectedModel = modelSelect.value;
  
  const variantsJson = JSON.parse(form.querySelector('.card-variant-json').textContent);
  
  variantIdInput.value = '';
  setCardButtonActive(atcBtn, false);
  
  if (!selectedBrand || !selectedModel) return;
  
  // Match variant
  const matchedVariant = variantsJson.find(variant => {
    return variant.options[brandIndex] === selectedBrand && variant.options[modelIndex] === selectedModel;
  });
  
  if (matchedVariant && matchedVariant.available) {
    variantIdInput.value = matchedVariant.id;
    setCardButtonActive(atcBtn, true);
  }
};

function setCardButtonActive(btn, active) {
  if (active) {
    btn.disabled = false;
    btn.className = 'card-atc-btn w-full py-3 bg-brand text-white text-xs font-bold uppercase tracking-wider rounded-xl cursor-pointer transition-all';
  } else {
    btn.disabled = true;
    btn.className = 'card-atc-btn w-full py-3 bg-surface-container-high text-muted text-xs font-bold uppercase tracking-wider rounded-xl cursor-not-allowed transition-all';
  }
}

window.addCardProductToCart = function(btn) {
  if (btn.disabled) return;
  const form = btn.closest('.product-card-form');
  if (!form) return;
  
  const variantId = form.querySelector('.card-variant-id').value;
  if (!variantId) return;
  
  btn.setAttribute('disabled', 'true');
  btn.textContent = 'Ekleniyor...';
  
  let formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };
  
  fetch(window.shopUrl + '/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Varyant sepete eklenemedi.');
    }
    return response.json();
  })
  .then(data => {
    if (window.updateCartBadgeAndDrawer) {
      window.updateCartBadgeAndDrawer(true);
    } else {
      window.location.reload();
    }
  })
  .catch(err => {
    console.error('Error adding card product to cart:', err);
    alert('Ürün sepete eklenirken bir hata oluştu.');
  })
  .finally(() => {
    btn.removeAttribute('disabled');
    btn.textContent = 'Sepete Ekle';
  });
};
